import { default as axios } from 'axios'

declare const window: any

class AxiosVendor {
    static init() {
        window.axios = axios
    }
}

export default AxiosVendor
